/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLoginDto } from '../../models/backend-login-dto';
import { BackendLoginRequestDto } from '../../models/backend-login-request-dto';

export interface AccountLoginCreate$FormData$Params {
  body: BackendLoginRequestDto;
}

export function accountLoginCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccountLoginCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLoginDto>> {
  const rb = new RequestBuilder(rootUrl, accountLoginCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLoginDto>;
    }),
  );
}

accountLoginCreate$FormData.PATH = '/api/account/login/';
